/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseBigDecimal } from '../models/api-response-big-decimal';
import { ApiResponseFlowInprogress } from '../models/api-response-flow-inprogress';
import { ApiResponsePagedResultFlowInprogress } from '../models/api-response-paged-result-flow-inprogress';
import { ApiResponseString } from '../models/api-response-string';
import { ApiResponseVoid } from '../models/api-response-void';
import { createFlow } from '../fn/flow-in-progress-api/create-flow';
import { CreateFlow$Params } from '../fn/flow-in-progress-api/create-flow';
import { getFlowByConversation } from '../fn/flow-in-progress-api/get-flow-by-conversation';
import { GetFlowByConversation$Params } from '../fn/flow-in-progress-api/get-flow-by-conversation';
import { getTotalCost1 } from '../fn/flow-in-progress-api/get-total-cost-1';
import { GetTotalCost1$Params } from '../fn/flow-in-progress-api/get-total-cost-1';
import { searchFlowInprogress } from '../fn/flow-in-progress-api/search-flow-inprogress';
import { SearchFlowInprogress$Params } from '../fn/flow-in-progress-api/search-flow-inprogress';
import { stopFlow } from '../fn/flow-in-progress-api/stop-flow';
import { StopFlow$Params } from '../fn/flow-in-progress-api/stop-flow';

@Injectable({ providedIn: 'root' })
export class FlowInProgressApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createFlow()` */
  static readonly CreateFlowPath = '/v1/api/ui/flows';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFlow()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createFlow$Response(params: CreateFlow$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return createFlow(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createFlow$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createFlow(params: CreateFlow$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.createFlow$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

  /** Path part for operation `stopFlow()` */
  static readonly StopFlowPath = '/v1/api/ui/flows/stop';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stopFlow()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stopFlow$Response(params: StopFlow$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseString>> {
    return stopFlow(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stopFlow$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stopFlow(params: StopFlow$Params, context?: HttpContext): Observable<ApiResponseString> {
    return this.stopFlow$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseString>): ApiResponseString => r.body)
    );
  }

  /** Path part for operation `searchFlowInprogress()` */
  static readonly SearchFlowInprogressPath = '/v1/api/ui/flows/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchFlowInprogress()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchFlowInprogress$Response(params: SearchFlowInprogress$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultFlowInprogress>> {
    return searchFlowInprogress(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchFlowInprogress$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchFlowInprogress(params: SearchFlowInprogress$Params, context?: HttpContext): Observable<ApiResponsePagedResultFlowInprogress> {
    return this.searchFlowInprogress$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultFlowInprogress>): ApiResponsePagedResultFlowInprogress => r.body)
    );
  }

  /** Path part for operation `getFlowByConversation()` */
  static readonly GetFlowByConversationPath = '/v1/api/ui/flows/of-conv/{convRef}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFlowByConversation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFlowByConversation$Response(params: GetFlowByConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseFlowInprogress>> {
    return getFlowByConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFlowByConversation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFlowByConversation(params: GetFlowByConversation$Params, context?: HttpContext): Observable<ApiResponseFlowInprogress> {
    return this.getFlowByConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseFlowInprogress>): ApiResponseFlowInprogress => r.body)
    );
  }

  /** Path part for operation `getTotalCost1()` */
  static readonly GetTotalCost1Path = '/v1/api/ui/flows/cost/total';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTotalCost1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalCost1$Response(params: GetTotalCost1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBigDecimal>> {
    return getTotalCost1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTotalCost1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalCost1(params: GetTotalCost1$Params, context?: HttpContext): Observable<ApiResponseBigDecimal> {
    return this.getTotalCost1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBigDecimal>): ApiResponseBigDecimal => r.body)
    );
  }

}
